import { motion, useReducedMotion } from "framer-motion";

const P = { x: "32%", y: "6.5%" };

const starts = [
  { x: "100%", y: "22%", tone: "ink" },
  { x: "100%", y: "68%", tone: "sage" },
  { x: "78%", y: "100%", tone: "ink" },
  { x: "45%", y: "100%", tone: "ink" },
  { x: "72%", y: "0%", tone: "sage" },
  { x: "95%", y: "0%", tone: "ink" },
];

const Marker = () => (
  <>
    <rect
      x={P.x}
      y={P.y}
      width="20"
      height="20"
      transform="translate(-10 -10)"
      fill="none"
      stroke="#A6443E"
      strokeOpacity="0.45"
    />
    <rect x={P.x} y={P.y} width="7" height="7" transform="translate(-3.5 -3.5)" fill="#A6443E" />
  </>
);

export const ConvergingLines = ({ className = "", testId = "hero-motif" }) => {
  const reduce = useReducedMotion();

  const lineProps = (s) => ({
    x1: s.x,
    y1: s.y,
    x2: P.x,
    y2: P.y,
    stroke: s.tone === "sage" ? "#7A8475" : "#1A1A1A",
    strokeOpacity: s.tone === "sage" ? 0.35 : 0.1,
    strokeWidth: 1,
  });

  const tailProps = {
    x1: P.x,
    y1: P.y,
    x2: "0%",
    y2: P.y,
    stroke: "#1A1A1A",
    strokeOpacity: 0.22,
    strokeWidth: 1,
  };

  return (
    <svg className={className} aria-hidden="true" data-testid={testId}>
      {starts.map((s, i) =>
        reduce ? (
          <line key={i} {...lineProps(s)} />
        ) : (
          <motion.line
            key={i}
            {...lineProps(s)}
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 1.1, delay: 0.12 * i, ease: "easeInOut" }}
          />
        )
      )}
      {reduce ? (
        <line {...tailProps} />
      ) : (
        <motion.line
          {...tailProps}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.5, delay: 0.85, ease: "easeOut" }}
        />
      )}
      {reduce ? (
        <Marker />
      ) : (
        <motion.g
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1.2 }}
        >
          <Marker />
        </motion.g>
      )}
    </svg>
  );
};
